/* eslint-disable react/jsx-no-bind */
import {Helmet} from "react-helmet";
import Image from "./Image";
import NavigationControls from "./NavigationControls";
import PropTypes from "prop-types";
import React from "react";
import {checkProgress} from "../modules/checkProgress";
import {getPageTitle} from "../modules/StyleSurveyHelper";

class StyleSurveyMetalQuestion extends React.Component {

  static propTypes = {
    "answers": PropTypes.array.isRequired,
    "header": PropTypes.element.isRequired,
    "isMetalImage": PropTypes.bool.isRequired,
    "location": PropTypes.object.isRequired,
    "multiSelect": PropTypes.bool.isRequired,
    "nextRoute": PropTypes.string,
    "onAnswer": PropTypes.func.isRequired,
    "prevRoute": PropTypes.string,
    "skip": PropTypes.object,
    "surveyFields": PropTypes.object.isRequired
  };

  static defaultProps = {
    "isMetalImage": true,
    "nextRoute": null,
    "prevRoute": null,
    "skip": null
  };

  constructor (props) {
    super(props);

    this.state = {"isDisabled": true};
    this.fields = props.surveyFields;
  }

  componentDidMount = () => {
    this.checkForSelectedAnswer();
  }

  componentDidUpdate = () => {
    checkProgress();
  }

  updateField = (answer) => {
    Object.keys(answer.surveyFields).forEach((field) => {
      this.fields[field] = !this.fields[field];
    });
    this.checkForSelectedAnswer();
  }

  enableNext = () => {
    this.setState({"isDisabled": false});
  }

  disableNext = () => {
    this.setState({"isDisabled": true});
  }

  checkForSelectedAnswer = () => {
    const allSurveyFields = this.fields;
    const keys = Object.keys(allSurveyFields);
    const values = keys.map(value => allSurveyFields[value]);
    values.includes(true) ? this.enableNext() : this.disableNext();
  }

  render () {
    const {
      answers, header, isMetalImage, location, multiSelect, nextRoute, onAnswer, prevRoute, skip,
      surveyFields
    } = this.props;
    const {isDisabled} = this.state;
    const {pathname} = location;

    return (
      <React.Fragment>
        <Helmet>
          <div className="row">
            <title className="col-lg-6">
              {getPageTitle(pathname)}
            </title>
          </div>
        </Helmet>
        <div className="StyleSurveyMetalQuestion">
          <div className="row">
            <div className="col-lg-6 metal-header">
              {header}
            </div>
            <div className="col-lg-6">
              {
                answers.map(answer =>
                  <div
                    className="metal-response"
                    key={answer.prompt}
                    onClick={() => this.updateField(answer)}
                  >
                    <Image
                      answer={answer}
                      isMetalImage={isMetalImage}
                      label={
                        <p className="metal-label">
                          {answer.prompt}
                        </p>
                      }
                      location={location}
                      multiSelect={multiSelect}
                      nextRoute={nextRoute}
                      onAnswer={onAnswer}
                      surveyFields={surveyFields}
                    />
                  </div>)
              }
            </div>
          </div>
          <NavigationControls
            isDisabled={isDisabled}
            nextRoute={nextRoute}
            onAnswer={onAnswer}
            prevRoute={prevRoute}
            skip={skip}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default StyleSurveyMetalQuestion;
